import axios from 'axios';

const getBaseUrl = () => {
    if (window.location.hostname === 'localhost') {
        return 'https://ah.foxsol.net/api/v1';
    }
    const origin = window.location.origin;
    return `${origin}/api/v1`;
};

const baseURL = process.env.VUE_APP_API_URL || getBaseUrl();

const shouldUseCredentials = () => {
    if (window.location.hostname === 'localhost') {
        return false;
    }
    return window.location.hostname === 'ah.foxsol.net';
};

const api = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    timeout: 30000,
    withCredentials: shouldUseCredentials()
});

api.interceptors.request.use(
    config => {
        const token = localStorage.getItem('ahToken');

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;

            if (!config.data) {
                config.data = {};
            }

            if (typeof config.data === 'object' && !config.data.token) {
                config.data.token = token;
            }
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        let errorMessage = 'Unknown error occurred';

        if (error.response) {
            errorMessage = error.response.data?.message || `Server error: ${error.response.status}`;

            if (error.response.status === 401) {
                localStorage.removeItem('ahToken');

                if (window.location.pathname !== '/' && window.location.pathname !== '/login') {
                    window.location.href = '/';
                }
            }

        } else if (error.request) {
            errorMessage = 'No response from server. Please check your connection';
        } else {
            errorMessage = error.message;
        }

        return Promise.reject({
            error,
            message: errorMessage,
            config: error.config,
            response: error.response
        });
    }
);

const resetHeaders = () => {
    api.defaults.headers.common = {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    };

    const token = localStorage.getItem('ahToken');
    if (token) {
        api.defaults.headers.Authorization = `Bearer ${token}`;
    }
};

const testCORS = async () => {
    try {
        const response = await api.get('/cors-test');
        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export { resetHeaders, testCORS };
export default api;
